<template>
  <div>
    <v-toolbar
      flat
      color="white"
    >
      <v-text-field
        v-model="search"
        prepend-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog
        v-model="folderdialog"
        max-width="600px"
      >
        <v-btn
          slot="activator"
          icon
        >
          <v-icon>add_circle_outline</v-icon>
        </v-btn>
        <v-card>
          <v-toolbar
            card
            dense
            color="transparent"
          >

            <v-btn
              icon
              @click.native="close"
            >
              <v-icon>reply</v-icon>
            </v-btn>

            <v-btn
              icon
              @click.native="saveAndClose"
            >
              <v-icon>library_add</v-icon>
            </v-btn>

            <v-btn
              icon
              @click.native="save"
            >
              <v-icon>save</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="add"
            >
              <v-icon>add</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="deleterow"
            >
              <v-icon>delete</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="first"
            >
              <v-icon>first_page</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="next"
            >
              <v-icon>keyboard_arrow_left</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="previous"
            >
              <v-icon>keyboard_arrow_right</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="last"
            >
              <v-icon>last_page</v-icon>
            </v-btn>
            <v-menu
              bottom
              left
            >
              <v-btn
                slot="activator"
                icon
              >
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile
                  v-for="(item, i) in items"
                  :key="i"
                  click
                >
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-toolbar>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-form
              v-model="editedItem.valid"
              ref="form"
              lazy-validation
            >
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex
                    xs12
                    sm12
                  >
                    <v-autocomplete
                      hint="Atleast 3 Characters required"
                      :loading="loader"
                      chips
                      cache-items
                      flat
                      placeholder="Select only suggested Parent Folder"
                      prepend-icon="assistant"
                      :items='parentFolderDropItems'
                      v-model="editedItem.parentFolderID"
                      label="Parent Folder"
                      color="blue"
                      item-text="name"
                      item-value="folderID"
                    >
                    </v-autocomplete>
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                  >
                    <v-autocomplete
                      hint="Atleast 3 Characters required"
                      :loading="loader"
                      chips
                      cache-items
                      flat
                      placeholder="Select only suggested Main Folder"
                      prepend-icon="assistant"
                      :items='mainFolderDropItems'
                      v-model="editedItem.mainFolderID"
                      label="Main Folder"
                      color="blue"
                      item-text="name"
                      item-value="folderID"
                    >
                    </v-autocomplete>
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                  >
                    <v-autocomplete
                      hint="Atleast 3 Characters required"
                      :loading="loader"
                      chips
                      cache-items
                      flat
                      placeholder="Select only suggested Folder Type"
                      prepend-icon="assistant"
                      :items='folderTypeDropItems'
                      v-model="editedItem.folderTypeID"
                      label="Folder Type"
                      color="blue"
                      item-text="codeValue"
                      item-value="codeID"
                    >
                    </v-autocomplete>
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                  >
                    <v-text-field
                      v-model="editedItem.name"
                      label="Name"
                      :rules="editedItem.nameRules"
                      required
                      prepend-icon="select_all"
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                  >
                    <v-text-field
                      v-model="editedItem.description"
                      label="Description"
                      prepend-icon="description"
                    >
                      <div slot="label">
                        Description
                      </div>
                    </v-text-field>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md4
                  >
                    <v-autocomplete
                      label="Status"
                      prepend-icon="notes"
                      v-model="editedItem.statusCodeID"
                      :items="statusOptions"
                    >
                    </v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <delete-confirmation-dialog
            ref="formdeleteConfirmationDialog"
            heading="Are You Sure You Want To Delete?"
            message="Are You Sure You Want To Delete This Item Permanently?"
            @onConfirm="formDeleteItem"
          >
          </delete-confirmation-dialog>

        </v-card>
      </v-dialog>
    </v-toolbar>
    <app-section-loader :status="loader"></app-section-loader>
    
    <v-snackbar
      :top="y === 'top'"
      :timeout="timeout"
      v-model="snackbar"
    >
      {{ snackbarMessage }}
    </v-snackbar>
    <delete-confirmation-dialog
      ref="deleteConfirmationDialog"
      heading="Are You Sure You Want To Delete?"
      message="Are You Sure You Want To Delete This Item Permanently?"
      @onConfirm="deleteItem"
    >
    </delete-confirmation-dialog>
  </div>
</template>
<script>
import { getFolders, getFolder, getFolderTypes, createFolders, updateFolders, deleteFolders } from '@/api/folder';
import GlobalMessage from '@/constant'
export default {
  components: {

  },
  data: () => ({
    folderdialog: false,
    loader: false,
    search: '',
    statusOptions: [
      { text: 'Active', value: 1 },
      { text: 'InActive', value: 2 }
    ],

    snackbar: false,
    snackbarMessage: '',
    timeout: 2000,
    y: 'top',
  
    gridItems: [],
    dropItems: [],
    parentFolderDropItems: [],
    folderTypeDropItems: [],
    mainFolderDropItems: [],
    editedIndex: -1,
    selectedItem: null,
    editedItem: {
      valid: false,
      folderID: -1,
      name: '',
      nameRules: [v => !!v || 'Name is required'],
      description: '',
      parentFolderID: null,
      parentFolderName: null,
      mainFolderID: null,
      mainFolderName: null,
      folderTypeName: null,
      folderTypeID: null,
      sessionID: null,
      addedByUserID: null,
      addedDate: new Date(),
      statusCodeID: 1,
      statusCode: 'Active',
      modifiedByUserID: null,
      modifiedDate: new Date()
    },
    defaultItem: {
      valid: false,
      folderID: -1,
      name: '',
      nameRules: [v => !!v || 'Name is required'],
      description: '',
      parentFolderID: null,
      parentFolderName: null,
      mainFolderID: null,
      mainFolderName: null,
      folderTypeName: null,
      folderTypeID: null,
      sessionID: null,
      addedByUserID: null,
      addedDate: new Date(),
      statusCodeID: 1,
      statusCode: 'Active',
      modifiedByUserID: null,
      modifiedDate: new Date()
    },
    searchItem: { action: '', Id: null, searchString: 'searchString', },
    items: [
      { title: 'Clear Items' },
      { title: 'Post' },
      { title: 'Delete' },
      { title: 'Print' }
    ],
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Add Folder' : 'Edit Folder';
    }
  },

  watch: {
    folderdialog (val) {
      val || this.close();
    }
  },

  created () {
    this.initialize();
  },

  methods: {
    initialize () {
      this.loader = true;
      console.log(this.$store.state.auth.userId);
      
      getFolders('')
        .then(response => {
          this.gridItems = response.data;
          this.parentFolderDropItems = response.data;
          this.mainFolderDropItems = response.data;
          //this.folderTypeDropItems = response.data;
          this.loader = false;
          console.log(this.gridItems);
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
      getFolderTypes('')
        .then(response1 => {
          //this.gridItems = response1.data;
          this.folderTypeDropItems = response1.data;
          this.loader = false;
          console.log(this.folderTypeDropItems);
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    editItem (item) {
      this.editedIndex = this.gridItems.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.folderdialog = true;
    },
    onDeleteItem (item) {
      this.$refs.deleteConfirmationDialog.openDialog();
      this.selectedItem = item;
    },
    deleteItem () {
      this.$refs.deleteConfirmationDialog.close();
      this.loader = true;
      let index = this.gridItems.indexOf(this.selectedItem);
      deleteFolders(this.selectedItem)
        .then(() => {
          this.loader = false;
          this.selectedItem = null;
          this.gridItems.splice(index, 1);
          window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.DELETE);
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    close () {
      this.folderdialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    saveAndClose () {
      this.save();
      this.close();
    },
    toolfunction () {

      getFolder(this.searchItem)
        .then(response => {

          if (response.data.folderID != null) {

            this.editedItem = response.data;
            let index = this.gridItems.map(item => item.folderID).indexOf(response.data.folderID)
            this.editedIndex = index;

          }
          else {
            window.getApp.$emit('APP_API_SUCCESS', 'No Records to view');
          }

        })
        .catch(error => {
          // this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    first () {
      this.searchItem.action = 'First';
      this.searchItem.Id = this.editedItem.folderID;
      // this.selectedItem.searchString = 'first';
      this.toolfunction();
    },
    last () {
      this.searchItem.action = 'Last';
      this.searchItem.Id = this.editedItem.folderID;
      //this.selectedItem.searchString = 'last';

      this.toolfunction();
    },
    previous () {
      this.searchItem.action = 'Previous';
      this.searchItem.Id = this.editedItem.folderID;
      //this.selectedItem.searchString = 'previous';
      this.toolfunction();
    },
    next () {
      this.searchItem.action = 'Next';
      this.searchItem.Id = this.editedItem.folderID;
      // this.selectedItem.searchString = 'next';
      this.toolfunction();
    },
    add () {

      this.editedItem.valid = false;
      this.editedItem.folderID = -1;
      this.editedItem.name = '';
      this.editedItem.nameRules = [v => !!v || 'Name is required'];
      this.editedItem.description = '';
      this.editedItem.parentFolderID = this.editedItem.parentFolderID;
      this.editedItem.mainFolderID = this.editedItem.mainFolderID;
      this.editedItem.folderTypeID = this.editedItem.folderTypeID;
      this.editedItem.addedByUserID = this.$store.state.auth.userId;
      this.editedItem.addedDate = new Date();
      this.editedItem.statusCodeID = 1;
      this.editedItem.statusCode = 'Active';
      this.editedItem.modifiedByUserID = this.$store.state.auth.userId;
      this.editedItem.modifiedDate = new Date();
      this.editedIndex = -1;
    },
    deleterow () {
      this.$refs.formdeleteConfirmationDialog.openDialog();
    },
    formDeleteItem () {
      this.$refs.formdeleteConfirmationDialog.close();
      // this.loader = true;
      let index = this.editedIndex;

      deleteFolders(this.editedItem.folderID)
        .then(() => {
          this.add();
          this.gridItems.splice(index, 1);
          window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.DELETE);
        })
        .catch(error => {
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    close () {
      this.folderdialog = false;
      this.initialize();
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save () {
      if (this.$refs.form.validate()) {
        this.loader = true;
        let index = this.editedIndex;
        if (this.editedIndex > -1) {
          Object.assign(this.gridItems[this.editedIndex], this.editedItem);
          this.editedItem.parentFolderName = this.editedItem.name;
          this.editedItem.mainFolderName = this.editedItem.name;
          this.editedItem.folderTypeName = this.editedItem.folderTypeName;
          this.editedItem.modifiedByUserID = this.$store.state.auth.userId;
          this.editedItem.modifiedDate = new Date();
          this.editedItem.addedByUserID = this.$store.state.auth.userId;
          this.editedItem.addedDate = new Date();
          updateFolders(this.editedItem)
            .then(response => {
              Object.assign(this.gridItems[index], response.data);
              this.loader = false;
              window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.UPDATE);
            })
            .catch(error => {
              this.loader = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });
        } else {
          // this.editedItem.parentFolderID = this.editedItem.folderID;
          this.editedItem.folderID = parseInt(Math.random() * 100) + 1024; // mock a id

          // this.editedItem.parentFolderName = this.editedItem.name;
          this.editedItem.addedByUserID = this.$store.state.auth.userId;
          this.editedItem.addedDate = new Date();
          this.editedItem.statusCodeID = 1;
          createFolders(this.editedItem)
            .then(response => {
              this.gridItems.push(response.data);
              this.loader = false;
              this.editedItem = response.data;
              let index = this.gridItems.map(item => item.folderID).indexOf(response.data.folderID)
              this.editedIndex = index;
              window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.SAVE);
            })
            .catch(error => {
              this.loader = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });
        }
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/document/PublicFolderMain.vue